import { WarningCircle } from '@phosphor-icons/react';
import type { FC } from 'react';

interface ErrorMessageProps {
  /** The message to show. `null` renders nothing, so a caller can pass its error state straight in. */
  message: string | null;
}

/**
 * An inline failure notice, placed where the content it replaces or precedes would be.
 *
 * Red is spent here and nowhere else on the page: it is the one thing that has gone wrong, so it
 * does not compete with a red delete button two rows down.
 */
export const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => {
  if (!message) return null;

  return (
    <div className="flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 p-4">
      <WarningCircle size={20} className="shrink-0 text-red-500" aria-hidden="true" />
      <p className="m-0 text-sm text-red-700 [text-wrap:pretty]">{message}</p>
    </div>
  );
};
